import { createFileRoute } from '@tanstack/react-router';
import { ScopedUsersTable } from '../../components/scoped/ScopedUsersTable';
import { TENANT_DESCRIPTOR } from '../../components/scoped/scopeDescriptors';

export const Route = createFileRoute('/_authenticated/_layout/tenant/users/')({
    component: () => <ScopedUsersTable descriptor={TENANT_DESCRIPTOR} />,
});
